export function getInsight({
  totalNegocios,
  totalFechamentos,
  visitasMes,
  imoveisAtivos,
}) {
  if (totalNegocios < 3)
    return 'Cadastre mais negócios para destravar leituras mais precisas sobre seu funil de vendas.';

  if (visitasMes > totalNegocios)
    return 'Registrar visitas como negócios ajuda a identificar onde você perde conversão.';

  if (imoveisAtivos > totalNegocios)
    return 'Transformar imóveis em negócios permite entender quais tipos de estoque realmente giram.';

  if (totalFechamentos === 0 && totalNegocios < 6)
    return 'Cadastre mais negócios para aumentar suas chances reais de fechamento.';

  if (visitasMes > 0 && totalNegocios === 0)
    return 'Transforme visitas em negócios para não perder oportunidades já geradas.';

  if (imoveisAtivos > visitasMes && visitasMes > 0)
    return 'Ative seus imóveis com mais visitas para aumentar o giro do estoque.';

  if (totalNegocios > 0 && totalFechamentos === 0)
    return 'Avance seus negócios ativos para aproximá-los do fechamento.';

  if (totalNegocios < 8)
    return 'Aumentar o volume de negócios ativos melhora a previsibilidade de fechamento.';

  return 'Um funil mais cheio reduz pressão por fechamento imediato.';
}
